import React, { useMemo } from 'react';
import { TAX_YEAR_FLOOR, useTaxYearStore } from '../../stores/useTaxYearStore';
import './TaxYearSelector.css';

/**
 * TaxYearSelector
 *
 * Persistent header control for the Tax Reporting section. Years are a
 * fixed range from TAX_YEAR_FLOOR (the platform's tax-data floor) through
 * the current calendar year — the picker is data-agnostic so the operator
 * can select a year that has not yet been processed and kick off a new
 * pipeline run from CTR-014.
 *
 * The default value is owned by useTaxYearStore (prior calendar year);
 * this component just renders it.
 */
export const TaxYearSelector: React.FC = () => {
  const selectedYear = useTaxYearStore((s) => s.selectedYear);
  const setSelectedYear = useTaxYearStore((s) => s.setSelectedYear);

  const years = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const list: number[] = [];
    for (let year = currentYear; year >= TAX_YEAR_FLOOR; year--) {
      list.push(year);
    }
    return list;
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const year = parseInt(event.target.value, 10);
    if (!Number.isNaN(year)) {
      setSelectedYear(year);
    }
  };

  return (
    <div className="tax-year-selector">
      <label htmlFor="tax-year-select" className="tax-year-selector__label">
        Tax Year:
      </label>
      <select
        id="tax-year-select"
        className="tax-year-selector__select"
        value={selectedYear}
        onChange={handleChange}
      >
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>
  );
};
